export default __webpack_public_path__ + "assets/images/a7d9bb8b3ea6d7955f173e7815bdebac.png";